import React from 'react'
import { Grid, Button, CircularProgress } from '@mui/material'
import { GetApp } from '@mui/icons-material'

interface StockMovementButtonBarProps {
  onExportClick: () => void
  isExporting?: boolean
  disabled?: boolean
}

export const StockMovementButtonBar: React.FC<StockMovementButtonBarProps> = ({
  onExportClick,
  isExporting = false,
  disabled = false
}) => {
  return (
    <Grid container justifyContent='flex-end' spacing={2}>
      <Grid container item xs={12} md={8} spacing={3} justifyContent='flex-end'>
        <Grid
          item
          xs={12}
          lg={3}
          justifyContent='flex-end'
          alignContent='flex-end'
          alignItems='flex-end'
        >
          <Button
            fullWidth
            variant='contained'
            color='primary'
            size='small'
            onClick={onExportClick}
            disabled={isExporting || disabled}
            startIcon={
              isExporting ? <CircularProgress size={20} /> : <GetApp />
            }
          >
            {isExporting ? 'Exportando...' : 'Exportar Excel'}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
